//@flow
import React from 'react';
import injectSheet from 'react-jss';
// import { Link } from 'react-router-dom';
import { SessionedLink } from 'h-commons';


const UpgradePlan = (props: Props) => {
    const { classes, content } = props;
    return (
        <div className={classes.root}>
            <div className={classes.centered}>
                <div className={`h-h2`}>
                    {content}
                </div>
                <div className={`${classes.marginTop20}`}>
                    <SessionedLink
                        type="Link"
                        to="/app/settings/account/upgrade"
                        className="h-primary-button"
                    >
                        Upgrade Hiver Account
                    </SessionedLink>
                </div>

            </div>
        </div>
    );
}
type Props = {
    classes: Object,
    content: string | Node
}

const style = {
    root: {
        height: '100%',
        minHeight: '65vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    centered: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    marginTop20: {
        marginTop: '20px'
    }
}
export default injectSheet(style)(UpgradePlan);